import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/auth";
import parse from "html-react-parser";
import {
  getPrice,
  getPriceSymbole,
  dateInMDY,
  OrderStatusFormat,
} from "../Helper";
import { useGetOrderDataAPI } from "../hooks/useAllCategoryData";
import axios from "axios";
export default function MyOrders() {
  const [searchParams, setSearchParams] = useSearchParams();
  const symbol = getPriceSymbole();
  const [auth] = useAuth();
  const [orderMsg, setOrderMsg] = useState("");
  const [userId] = useState(auth?.user?.id);

  const prmData = Object.fromEntries([...searchParams]);
  const {
    data: orderData,
    isLoading: loading,
    error,
  } = useGetOrderDataAPI(auth?.user?.id);

  const downloadPDF = async (order_no) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/order/generate-invoice/${order_no}`,
        {
          responseType: "blob",
        }
      );
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(pdfBlob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", `order_invoice_${order_no}.pdf`);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };
  useEffect(() => {
    if (prmData && prmData?.o_id > 0) {
      const authData = JSON.parse(localStorage.getItem("auth"));
      if (authData?.user) {
        authData.user.welcome_discount_use = 1;
        localStorage.setItem("auth", JSON.stringify(authData));
      }
    }
  }, [prmData])
  return (
    <Layout title="My Orders | Chaashni Couture">
      <div className="site-content-wrap my-account">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="sustom-heading-h1">
                My <span> Orders</span>
              </h1>

              {prmData && prmData?.o_id > 0 ? (
                <div className="alert alert-success text-center mb-5">
                  Order Successfully Placed, Order No. is{" "}
                  <strong>{prmData?.o_id}</strong>
                </div>
              ) : (
                ""
              )}

              {error && <div className="no-order-found"></div>}
              {loading && (
                <div className="loading-div">
                  <span>Loading...</span>
                </div>
              )}
              {!loading && (
                <div className="content-box">
                  <div className="wishlist-table table-responsive">
                    <table className="shop_table cart wishlist_table custom-table">
                      <thead>
                        <tr>
                          <th className="order-th">Order</th>
                          <th className="data-th">Date</th>
                          <th className="status-th">Status</th>
                          <th className="total-th">Total</th>
                          <th className="status-th">Invoice</th>
                          <th className="action-th">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderData?.length > 0 &&
                          orderData?.map((item, index) => (
                            <tr key={index}>
                              <td className="order-th">
                                <Link to={`/orders-detail/${item.id}`}>
                                  #{item.id}
                                </Link>
                              </td>
                              <td className="data-th">
                                {dateInMDY(item.created_at)}
                              </td>
                              <td className="status-th">
                                {item?.order_status === "pending" ||
                                  item?.order_status === "confirmed" ||
                                  item?.order_status === "processing" ||
                                  item?.order_status === "out_for_delivery" ? (
                                  <Link
                                    title="Order Track"
                                    to={`/trackorder/${item.id}`}
                                  >
                                    {parse(
                                      OrderStatusFormat(item.order_status)
                                    )}
                                  </Link>
                                ) : (
                                  parse(OrderStatusFormat(item?.order_status))
                                )}
                              </td>
                              <td className="total-th">
                                {item.currency}{" "}
                                {Math.round(
                                  item.order_amount * item.exchange_rate
                                )}
                              </td>
                              <td className="total-th">
                                {item.cod !== 1 ? (
                                  <Link
                                    title="Download Invoice"
                                    onClick={() => {
                                      downloadPDF(item.id);
                                    }}
                                  >
                                    <i className="fa-solid fa-file-pdf fa-fw"></i>
                                  </Link>
                                ) : (
                                  <span>--</span>
                                )}
                              </td>
                              <td className="action-th">
                                <Link
                                  title="Order Details"
                                  to={`/orders-detail/${item.id}`}
                                >
                                  <i className="fa fa-eye"></i>
                                </Link>
                                {item?.order_status === "pending" ||
                                  item?.order_status === "confirmed" ||
                                  item?.order_status === "processing" ||
                                  item?.order_status === "out_for_delivery" ? (
                                  <>
                                    |
                                    <Link
                                      title="Order Track"
                                      to={`/trackorder/${item.id}`}
                                    >
                                      <i className="fa fa-truck"></i>
                                    </Link>
                                  </>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))}
                        {orderData?.length === 0 && (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "center" }}>
                              <img
                                src="/images/sorry.svg"
                                alt=""
                                style={{ maxWidth: "200px" }}
                              />
                              <div style={{ padding: "10px 0 0" }}>
                                No data to show
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
